import type { SVGProps } from 'react';

const SvgTwoWayConversionSms = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="M17.84 26.13a.6.6 0 0 1-.59.59l-6.87-.06a.86.86 0 0 0-.4.11l-4.75 2.92v-2.28a.75.75 0 0 0-.75-.75H2.3a.59.59 0 0 1-.6-.59V12.53a.6.6 0 0 1 .6-.59h3.59v-1.5H2.3a2.1 2.1 0 0 0-2.1 2.09v13.54a2.1 2.1 0 0 0 2.1 2.09h1.43V31a.75.75 0 0 0 .38.65.71.71 0 0 0 .37.1.77.77 0 0 0 .39-.11l5.72-3.52 6.66.06a2.1 2.1 0 0 0 2.1-2.09v-2.77h-1.5Z" />
      <path d="M29.44.21H10.17a2.36 2.36 0 0 0-2.36 2.36v16.3a2.36 2.36 0 0 0 2.36 2.35h8.64l6.62 3.87a.76.76 0 0 0 .38.11.79.79 0 0 0 .37-.1.76.76 0 0 0 .38-.65v-3.23h2.88a2.36 2.36 0 0 0 2.36-2.35V2.57A2.36 2.36 0 0 0 29.44.21Zm.86 18.66a.86.86 0 0 1-.86.85h-3.63a.75.75 0 0 0-.75.75v2.67l-5.67-3.31a.7.7 0 0 0-.38-.11h-8.84a.85.85 0 0 1-.86-.85V2.57a.86.86 0 0 1 .86-.86h19.27a.87.87 0 0 1 .86.86Z" />
      <path d="M12.79 7.7h13.97v1.5H12.79zM12.79 12.52h7.58v1.5h-7.58z" />
    </g>
  </svg>
);

export default SvgTwoWayConversionSms;
